<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="存储溢出类型">
                <a-select placeholder="请选择" v-model="queryParam.overflowType" style="width: 100%" allow-clear>
                  <a-select-option :value="0"> 不允许超出存储 </a-select-option>
                  <a-select-option :value="1"> 允许超出存储 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select placeholder="请选择" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option :value="0"> 禁用 </a-select-option>
                  <a-select-option :value="1"> 有效 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
      >
        <span slot="overflowType" slot-scope="text, record">
          <span v-if="record.overflowType == 0">不允许超出存储</span>
          <span v-if="record.overflowType == 1">允许超出存储</span>
        </span>
        <span slot="status" slot-scope="text, record">
          <span v-if="record.status == 0">有效</span>
          <span v-if="record.status == 1">禁用</span>
        </span>
        <span slot="action" slot-scope="text, record">
          <a
            @click="$refs.vrForm.handleUpdate(record, undefined)"
            v-hasPermi="['10b98637049fb72c3493a8f4b983d745d:0:d']"
          >
            编辑
          </a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>
<script>
import { fetchList } from '@/api/VR/proxyStorage/index'

export default {
  data() {
    return {
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        overflowType: undefined,
        status: undefined,
      },
      loading: false,
      tableSize: 'default',
      list: [],
      total: 0,
      selectedRowKeys: [],
      columns: [
        {
          title: '单位标识',
          dataIndex: 'tenantId',
        },
        {
          title: '存储溢出类型',
          dataIndex: 'overflowType',
          scopedSlots: { customRender: 'overflowType' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
        },

        {
          title: '到期时间',
          dataIndex: 'expireTime',
        },
        {
          title: '备注',
          dataIndex: 'remark',
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  methods: {
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((res) => {
        this.loading = false
        this.list = res.data.records
        this.total = res.data.total
      })
    },
    handleQuery() {
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        overflowType: undefined,
        status: undefined,
      }
      this.getList()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
  },
  mounted() {
    this.getList()
  },
}
</script>
<style lang="scss" scoped></style>
